import { StyleSheet } from "react-native";
import type { ArrowsComponentProps } from "rn-calendar-component";

import { Block } from "@stepapp/ui";

import Arrow from "./Arrow";

const CalendarArrows = ({ onArrowPress, listWidth }: ArrowsComponentProps) => {
  return (
    <Block alignCenter justifySpace row style={styles.container} width={listWidth / 8}>
      <Arrow direction="left" onPress={onArrowPress} />
      <Arrow direction="right" onPress={onArrowPress} />
    </Block>
  );
};

export default CalendarArrows;

const styles = StyleSheet.create({
  container: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
